var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.07422 16.2759C1.41162 16.2759 0.503418 15.3677 0.503418 13.6904V2.74072C0.503418 1.0708 1.41162 0.155273 3.07422 0.155273H6.38477V5.97803C6.38477 6.85693 6.82422 7.29639 7.71045 7.29639H13.4893V13.6904C13.4893 15.3604 12.5811 16.2759 10.9185 16.2759H3.07422ZM8.02539 6.10986C7.7251 6.10986 7.57129 5.96338 7.57129 5.66309V0.221191C7.95215 0.257812 8.32568 0.550781 8.72852 0.960938L12.6689 4.93799C13.0938 5.37012 13.394 5.729 13.4233 6.10986H8.02539Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIconWhite);
export default __webpack_public_path__ + "static/media/doc-icon-white.cfab8fc5b9f95bc10b54e9703e9dff6d.svg";
export { ForwardRef as ReactComponent };